export { default as default } from './modules/write/writeXlsxFileBrowser.js'
// export { default as Integer } from './modules/types/Integer.js'
// export { default as Email } from './modules/types/Email.js'
// export { default as URL } from './modules/types/URL.js'
